export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-4.4e876dee.png";